import { render, staticRenderFns } from "./KitchenControls.vue?vue&type=template&id=54884368&scoped=true"
import script from "./KitchenControls.vue?vue&type=script&lang=js"
export * from "./KitchenControls.vue?vue&type=script&lang=js"
import style0 from "./KitchenControls.vue?vue&type=style&index=0&id=54884368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54884368",
  null
  
)

export default component.exports